"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Pages = function Pages(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 254.313 254.313'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M11.749,73.933l111.871,59.819c1.104,0.591,2.32,0.886,3.536,0.886s2.432-0.295,3.536-0.886\r l111.871-59.819c2.44-1.305,3.964-3.847,3.964-6.614s-1.523-5.309-3.964-6.614L130.692,0.886c-2.209-1.182-4.863-1.182-7.072,0\r L11.749,60.705c-2.44,1.305-3.964,3.847-3.964,6.614S9.309,72.628,11.749,73.933z M127.156,16.005l95.966,51.314l-95.966,51.314\r L31.19,67.319L127.156,16.005z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M242.563,120.561l-32.612-17.438c-3.653-1.954-8.197-0.575-10.15,3.077\r c-1.953,3.653-0.575,8.197,3.078,10.15l20.243,10.824l-95.966,51.314L31.19,127.175l20.478-10.95\r c3.653-1.953,5.031-6.498,3.078-10.15c-1.953-3.652-6.498-5.03-10.15-3.077l-32.847,17.563c-2.44,1.305-3.964,3.847-3.964,6.614\r s1.523,5.309,3.964,6.614l111.871,59.819c1.104,0.591,2.32,0.886,3.536,0.886s2.432-0.295,3.536-0.886l111.871-59.819\r c2.44-1.305,3.964-3.847,3.964-6.614S245.004,121.866,242.563,120.561z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M242.563,180.38l-31.578-16.885c-3.654-1.953-8.197-0.575-10.15,3.077\r c-1.953,3.653-0.575,8.197,3.078,10.15l19.209,10.271l-95.966,51.314L31.19,186.994l19.001-10.16\r c3.653-1.953,5.031-6.498,3.078-10.15s-6.498-5.031-10.15-3.077l-31.37,16.774c-2.44,1.305-3.964,3.847-3.964,6.614\r s1.523,5.309,3.964,6.614l111.871,59.819c1.104,0.591,2.32,0.886,3.536,0.886s2.432-0.295,3.536-0.886l111.871-59.819\r c2.44-1.305,3.964-3.847,3.964-6.614S245.004,181.685,242.563,180.38z'
  })));
};
/* eslint-enable */
var _default = Pages;
exports["default"] = _default;